import loadable from '@loadable/component';

export const UserDashboardPostAListingPageLoadable = loadable(
  () => import('./UserDashboardPostAListingPage'),
  { resolveComponent: (module) => module.UserDashboardPostAListingPage },
);
